import { render, staticRenderFns } from "./GlitchFont.vue?vue&type=template&id=0b28fbca&scoped=true&"
import script from "./GlitchFont.vue?vue&type=script&lang=js&"
export * from "./GlitchFont.vue?vue&type=script&lang=js&"
import style0 from "./GlitchFont.vue?vue&type=style&index=0&id=0b28fbca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28fbca",
  null
  
)

export default component.exports